import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/light-blue-arrow-left.svg'
import _imports_1 from '@/assets/loader.svg'


_pushScopeId("data-v-e1bd9e18")
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { id: "forgot-pass-wrap" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  id: "arrow",
  src: _imports_0
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Back to log in", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "form-group" }, " Please enter your account email below. We'll send you an email containing your new password. ", -1)
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "recover-email" }, " Account Email ", -1)
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = {
  key: 0,
  id: "error-message"
}
const _hoisted_11 = {
  key: 1,
  id: "error-message"
}
const _hoisted_12 = {
  key: 1,
  id: "loading-wrap"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.bounceTransition, "modal-body"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", {
            style: {"height":"30px","width":"30px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, [
            _createVNode(_component_CloseSVG, { propId: 'login-signup-close' })
          ])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            id: "return-to-login",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.returnToLogin && _ctx.returnToLogin(...args)))
          }, _hoisted_5),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              id: "recover-email",
              class: "form-input",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.emailInput = $event)),
              required: "",
              placeholder: "Your email"
            }, null, 512), [
              [_vModelText, _ctx.emailInput]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.showErrorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1))
              : (_ctx.showInvalidEmailError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, " This email is not registered. "))
                : _createCommentVNode("", true)
          ]),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                "aria-label": "Reset password",
                class: "modal-select-btn",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)))
              }, " Reset Password "))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
        ])
      ], 2)
    ], 2)
  ]))
}